import VueNotifications from 'vue-notifications';
import axios from 'axios';

export default {
	name: 'ManteAccion',
	data: () => ({
		buscaAuto: true,
		verForm: true,
		nombre: '',
		btnGuardar: false,
		inicio: true,
		reg: '',
		form: {},
		bform: {},
		lista: [],
		listaFiltrar: null,
		listaTermino: ''
	}),
	mounted () {
		if (this.buscaAuto) {
			this.buscar();
		}
	},
	methods: {
		guardar () {
			this.btnGuardar = true;
			axios
			.post(this.UrlBase+'/mante/set_'+this.nombre+'/'+this.reg, this.form)
			.then(r => {
				if (r.data.exito) {
					this.showSuccessMsg({message: r.data.mensaje});
					if (this.reg == '') {
						this.limpiar();
					}

					if (r.data.linea) {
						this.lista.push(r.data.linea);
					}
				} else {
					this.showWarnMsg({message: r.data.mensaje});
				}
				this.btnGuardar = false;
			})
			.catch(e => {
				this.showErrorMsg({message: e});
				this.btnGuardar = false;
			});
		},
		buscar () {
			axios
			.get(this.UrlBase+'/catalogo/get_lista?format=json', {params: {lista:[this.nombre]}})
			.then(r => {
				this.inicio = false;
				if (r.data.exito) {
					this.lista = r.data.lista[this.nombre];
				} else {
					alert(r.data.mensaje);
				}
			})
			.catch(e => {
				this.inicio = false;
				alert(e);
			});
		},
		limpiar () {
			this.reg = '';
			this.form = {};
		},
		editar (idx) {
			let tmp = this.filtrada[idx];

			this.reg = tmp.id;
			this.form = tmp;
			this.verForm = true;
		}
	},
	notifications: {
		showSuccessMsg: {
			type: VueNotifications.types.success,
			title: 'Excelente',
			message: 'That\'s the success!'
		},
		showInfoMsg: {
			type: VueNotifications.types.info,
			title: 'Hey',
			message: 'Here is some info for you'
		},
		showWarnMsg: {
			type: VueNotifications.types.warn,
			title: 'Wow',
			message: 'That\'s the kind of warning'
		},
		showErrorMsg: {
			type: VueNotifications.types.error,
			title: 'Wow-wow',
			message: 'That\'s the error'
		}
	},
	computed: {
		filtrada () {
			return this.lista.filter(obj => {
				if (this.listaFiltrar === null) {
					return true;
				} else {
					if (this.listaTermino === '') {
						return true;
					} else {
						return obj[this.listaFiltrar].toLowerCase().includes(this.listaTermino.toLowerCase());
					}
				}
			});
		}
	}
}